import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'

/**
 * Hook returning a method to fetch product search results with custom parameters.
 */
export const useProductSearchFetcher = () => {
    const {shopperSearch} = useCommerceApi()
    const {getTokenWhenReady} = useAccessToken()

    /**
     * Fetch product search results.
     *
     * @param {Object} parameters - Search parameters (e.g., { q, offset, limit, refine, etc. }).
     * @returns {Promise<Object>} The search results.
     */
    const fetchProductSearchResults = async (parameters) => {
        try {
            const token = await getTokenWhenReady()
            const response = await shopperSearch.productSearch({
                parameters: parameters,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            })
            return response
        } catch (error) {
            console.error('Error fetching product search results:', error)
            throw error
        }
    }

    return {fetchProductSearchResults}
}
